import { Button } from "react-bootstrap";
import "./Button.scss";

export default function (props) {
  const variant = props.variant ? props.variant : "primary";
  const size = props.size ? props.size : "default";
  return (
    <Button {...props} className={`Button ${props.className} Button_variant_${variant} Button_size_${size}`}>
      {props.children}
    </Button>
  );
}
